'use strict';

/* eslint no-undef: "off" */
/**
 * home customer reviews
 */
define('homeReviews',['getHomeReviewsApi', 'util', 'GAReport', 'lightbox'], function (getHomeReviewsApi, Util, GAReport) {
  return {
    template: '\n      <div class="in-product-reviews-wrapper in-container" v-if="isPageShow && reviewsList.length > 0">\n        <div class="in-add-rating">\n          <h5 class="in-review-title font-medium" :class="{\'in-no-reviews\': reviewsList.length === 0}">\n          <div class="in-review-title-box" v-text="i18n.cusReviews">\n          </div>\n          </h5>\n          <div class="in-reviews-list">\n            <div class="in-reviews" v-for="(item, index) in reviewsList">\n              <div>\n                <div class="in-preview-img">\n                  <a :href="item.product_info.url_link" @click="onReviewImageClicked(item.product_info, index)">\n                    <img v-lazy="item.product_info.images[0]"/>\n                  </a>\n                </div>\n                <div class="in-reviews-name">\n                  <h5 v-text="item.nickname"></h5>\n                </div>\n                <div class="in-reviews-content">\n                  <div class="in-reviews-left">\n                    <div class="in-rating">\n                      <ul>\n                        <li v-for="rating in ratingGroup">\n                          <!--\n                          <i class="iconfont" :class="{\'active\': rating.rating <= item.percent, \'icon-star\': rating.rating <= item.percent, \'icon-star-line\': !(rating.rating <= item.percent) }"></i>\n                          -->\n                          <img :src="require.toUrl(\'images/homepage-rating.png\')"/>\n                        </li>\n                      </ul>\n                    </div>\n                    <span v-text="item.created_at"></span>\n                  </div>\n                  <div class="in-reviews-right">\n                    <!--\n                    <h5 v-text="item.title"></h5>\n                    -->\n                    <p v-text="item.detail"></p>\n                    <!--\n                    <ul class="previewImg">\n                      <li v-for="(img, index) in item.images" :style="{backgroundImage: \'url(\'+ img +\')\'}" >\n                        <a :href="img" :data-lightbox="item.review_id"></a>\n                      </li>\n                    </ul>\n                    -->\n                  </div>\n                </div>\n              </div>\n            </div>\n\n          </div>\n        </div>\n      </div>\n    ',
    data: function data() {
      return {
        i18n: {
          cusReviews: 'CUSTOMER REVIEWS'
        },
        reviewsList: [],
        isPageShow: false,
        ratingGroup: [{
          rating: 20
        }, {
          rating: 40
        }, {
          rating: 60
        }, {
          rating: 80
        }, {
          rating: 100
        }],
        page_size: 4,
        page: 1
      };
    },
    mounted: function mounted() {
      this.init();
    },

    methods: {
      init: function init() {
        this.getHomeReviewList();
      },
      getHomeReviewList: function getHomeReviewList() {
        var _this = this;

        getHomeReviewsApi({
          page: this.page,
          pageSize: this.page_size
        }).then(function (resData) {

          console.log(resData);
          _this.reviewsList = resData.items;
          _this.isPageShow = true;

          if (_this.reviewsList.length > 0) {
            _this.reportShowReview();
          }
        });
      },
      reportShowReview: function reportShowReview() {
        new GAReport().customerClick({
          eventAction: 'HOME_REVIEW',
          eventCategory: 'HOME_REVIEW_#VERSION#'
        });
      },
      onReviewImageClicked: function onReviewImageClicked(data, index) {

        new GAReport().productClick({
          'eventAction': 'HOME_PRODUCT_CLICK_' + (data.name || '').toUpperCase(),
          'eventCategory': 'HOME_PRODUCT_CLICK_#VERSION#',
          'productList': [new GAReport().productItem(data, index)],
          'location': "TAB"
        });
      }
    }
  };
});
